import { StrictMode } from 'react'
import { Root } from '@/root'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom'

import { DeployChunkRouteErrorElement } from '@/components/core/deploy-chunk-route-error'
import { ScrollRestoration } from '@/components/core/scroll-restoration'
import { UnsavedChangesNotifier } from '@/components/core/unsaved-changes-notifier'
import { registerDeployChunkRecovery } from '@/lib/deploy-chunk-recovery'
import { routes } from '@/routes'

/** Before React runs so the first post-deploy navigation is covered (useEffect is too late). */
registerDeployChunkRecovery()

const root = createRoot(document.getElementById('root')!)

const router = createBrowserRouter([
	{
		path: '/',
		errorElement: <DeployChunkRouteErrorElement />,
		element: (
			<Root>
				<ScrollRestoration />
				<Outlet />
				<UnsavedChangesNotifier />
			</Root>
		),
		children: [...routes],
	},
])

root.render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>
)
